// extracted by mini-css-extract-plugin
module.exports = {"lia-dropdown-item":"BoardActionMenu_lia-dropdown-item__nePlZ","lia-dropdown-menu-index":"BoardActionMenu_lia-dropdown-menu-index__LQn8b"};